<template>
  <div style="max-width: 1600px">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator=">">
      <el-breadcrumb-item>Devices</el-breadcrumb-item>
      <el-breadcrumb-item>Device Info</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>

    <div class="container">
      <!-- 输入框 输入设备号 后面有一个按钮,View 用来查看详细信息 -->
      <el-input v-model="deviceNumber" placeholder="请输入设备号" class="input-with-button">
      </el-input>

      <el-button type="primary" @click="viewDeviceInfo" style="margin-left: 40px;">View Device Info</el-button>
    </div>




    <!-- 这里是设备信息的县市区 -->
    <div v-if="deviceInfo" class="device-info" ref="loadingTarget">

      <div class="item-container">
        <div class="info-item">
          <strong>ID:</strong> {{ deviceInfo.id }}
        </div>

        <div class="info-item">
          <strong>Device Number:</strong> {{ deviceInfo.deviceNumber }}
        </div>

        <div class="info-item">
          <strong>车型:</strong> {{ deviceInfo.type }}
        </div>

        <div class="info-item">
          <strong> 激活日期:</strong> {{ deviceInfo.activateDate }}
        </div>

        <div class="info-item">
          <strong> 绑卡日期:</strong> {{ deviceInfo.cardDate }}
        </div>

        <div class="info-item">
          <strong>试用日期:</strong> {{ deviceInfo.trialDate }}
        </div>

        <div class="info-item">
          <strong>首次付费日期:</strong> {{ deviceInfo.subsDate }}
        </div>

      </div>



      <div class="info-row" style="overflow-x: auto;">
        <div class="info-title">用户清单:</div>

        <div class="info-content"
          style="display: flex; overflow-x: auto; white-space: nowrap; padding-bottom: 10px; max-width: 1380px">
          <div class="user-container">
            <div v-for="(user, index) in deviceInfo.users" :key="index" class="user-item"
              style=" border-radius: 10px; width: 400px; margin-right: 10px; padding: 10px; box-shadow: 0 2px 4px rgba(0,0,0,0.2); display: flex; flex-direction: column;">
              <div><strong>ID:</strong> <span>{{ user.id }}</span></div>
              <div><strong>Name:</strong> <span>{{ user.name }}</span></div>
              <div><strong>Email:</strong> <span>{{ user.email }}</span></div>
              <div><strong>国家:</strong> <span>{{ user.registerCountry }}</span></div>
              <div><strong>注册设备:</strong> <span><a :href="`#/deviceInfo?deviceNumber=${user.registerDevice}`"
                    target="_blank">
                    {{ user.registerDevice }}</a></span></div>
              <div><strong>注册日期:</strong> <span>{{ user.registerTime }}</span></div>
              <div>
                <strong>登陆过设备:</strong>

                <span v-for="device in user.relatedDevices" :key="device">
                  <a :href="`#/deviceInfo?deviceNumber=${device}`" target="_blank">{{ device }}</a><br>
                </span>
              </div>

              <!-- 这里可以根据user对象中的其他属性进行展开 -->
            </div>
          </div>
        </div>
      </div>



      <el-divider></el-divider>
      <div class="info-row">
        <div class="info-title">Invoice 清单:</div>
        <div class="info-content">
          <!-- 判断数组是否为null或为空 -->
          <div v-if="deviceInfo.invoices && deviceInfo.invoices.length > 0"
            style="max-height: 480px; overflow-y: auto; display: flex; flex-wrap: wrap;">
            <!-- 遍历数组中的每个对象 -->
            <div v-for="(invoice, index) in deviceInfo.invoices" :key="index" class="invoice-item">
              <!-- 显示对象的字段信息 -->
              <p><strong>Invoice ID:</strong> {{ invoice.invoices_id }} <strong>Country:</strong> {{
        invoice.customer_country }} </p>
              <p><strong>订阅号: </strong>{{ invoice.subscription }}</p>
              <p> <strong>Cus Email: </strong>{{ invoice.customer_email }} </p>
              <p> <strong>Cus Name:</strong> {{ invoice.customer_name }} <strong>是否退款:</strong> {{ invoice.refund }}
              </p>
              <p><strong>Amount:</strong> {{ invoice.amount }} <strong>Paid At:</strong> {{ invoice.paid_at }} </p>
              <p><strong>Start:</strong> {{ invoice.period_start }} <strong>End: </strong>{{ invoice.period_end }} </p>
              <!-- 添加其他需要显示的字段 -->
            </div>
          </div>
          <div v-else>
            <!-- 数组是null或为空时的显示 -->
            <p>No Invoices Available</p>
          </div>
        </div>
      </div>



      <el-divider></el-divider>
      <!-- 新的活跃信息展示区 -->
      <div class="info-row">
        <div class="info-title">Actions:</div>




        <div style="width: 100%;">
          <div style=" width: 800px; margin-bottom: 20px;">
            <el-button style=" margin-left: 20px;" type="primary" @click="getDeviceActions20">获取最近20条活跃信息</el-button>
            <el-button style=" margin-left: 50px;" type="primary" @click="getDeviceActions200">获取最近200条活跃信息</el-button>
          </div>

        <div    v-if="actionsCondition===0" style="width: 95%;"  > 请主动点击按钮获取骑行信息,按照网络状况,可能需要等待2-20S</div>
        <div  :data="actionsCondition"  v-if="actionsCondition===1" style="width: 95%;" > 正在获取数据,按照网络状况,可能需要等待2-20S,请勿重复点击</div>
          <div style="width: 100%;" v-if="this.actionsCondition===2"  >
            <!-- 数据加载完成且有数据 -->
            <el-table :data="actions" style="width: 95%;" stripe   empty-text ="抱歉没有找到该设备的活跃行为信息">
              <el-table-column prop="date" label="Date" width="200"></el-table-column>
              <el-table-column prop="user_id" label="User ID" width="200"></el-table-column>
              <el-table-column prop="course_id" label="Course ID"   width="200"></el-table-column>
              <el-table-column prop="course_kind" label="Course Kind"   width="200"></el-table-column>
              <el-table-column prop="des" label="备注"   width="220"></el-table-column>
              <el-table-column prop="duration" label="Duration" width="180"></el-table-column>
            </el-table>
          </div>


        </div>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      deviceNumber: '',
      deviceInfo: {}, // 设备详细信息
      actions: [], // 设备的活跃信息的列表
      isLoading: false, // 标识数据是否正在加载
      actionsCondition:0,//下面活跃信息的状态,控制显示,0 还没有获取,请点击,1获取中,请等待,2拿到数据显示表格
    }
  },

  created() {
    // 如果路由参数中存在 deviceNumber，则将其赋值给 data 中的 deviceNumber
    if (this.$route.query.deviceNumber) {
      this.deviceNumber = this.$route.query.deviceNumber;
      // 接下来您可以根据 deviceNumber 来获取对应的设备信息
      this.viewDeviceInfo();
    }
  },

  methods: {

    // 查看设备详细信息按钮点击事件
    viewDeviceInfo() {
      let loadingInstance = this.$loading({
        lock: true,
        target: this.$refs.loadingTarget, // 指定局部遮罩的目标容器

        text: '正在加载中...大概要等7-15秒...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.2)'
      }); // 显示加载动画

      // 使用 axios 发送请求获取设备详细信息
      this.$http.get("da/device_info/" + this.deviceNumber)
        .then(response => {
          // 请求成功，将返回的数据赋值给 deviceInfo
          this.deviceInfo = response.data;
          //这边关闭加载动画, 后面继续加载不影响查看了
          loadingInstance.close(); // 关闭加载动画
          this.isLoading = false;
        })
        .catch(error => {
          // 请求失败，处理错误
          console.error('获取设备详细信息失败: ', error);
        })

      // 按照router url 判断是否需要刷新
      const currentRoute = this.$route;
      const targetRoute = { name: 'deviceInfo', query: { deviceNumber: this.deviceNumber } };

      // 检查当前路由和目标路由是否相同（包括查询参数）
      if (currentRoute.name !== targetRoute.name || currentRoute.query.deviceNumber !== targetRoute.query.deviceNumber) {
        // 如果当前路由和目标路由不相同，则执行导航操作
        this.$router.replace(targetRoute).catch(err => {
          // 忽略NavigationDuplicated错误，但对其他错误抛出
          if (err.name !== 'NavigationDuplicated') {
            throw err;
          }
        });
      }
    },
    getDeviceActions20(){
  
this.getDeviceActions(20)
    },
    getDeviceActions200(){

      this.getDeviceActions(200)
    },
    async getDeviceActions(num) {
this.actions = []
this.actionsCondition=1
let res = await this.$http.get("/da/device_actions/" + this.deviceNumber + "/" + num )  
this.actions = res.data
this.actionsCondition=2
},
  }
}





</script>

<style scoped>
.container {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: 5px;
}

.input-with-button {
  max-width: 300px;
}


.device-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  /* 使所有子项靠左对齐 */
}

.item-container {
  display: flex;
  /* 启用flex布局 */
  flex-wrap: wrap;
  /* 允许子元素在必要时换行 */
  gap: 20px;
  /* 设置元素之间的间距 */
  justify-content: flex-start;
  /* 子元素在主轴（这里是水平方向）上的对齐方式 */
  align-items: flex-start;
  /* 子元素在交叉轴（这里是垂直方向）上的对齐方式 */
}



.info-item {
  width: 400px;
  text-align: left;
}

.info-row {
  display: flex;
  margin-bottom: 10px;
  /* 为每行提供一些底部外边距 */
}

.info-title,
.info-content {
  margin-right: 20px;
  /* 标题和内容之间的间隔 */
}

.info-title {
  width: 180px;
  /* 设置标题宽度，以便对齐 */
  font-weight: bold;
}

.info-content {
  flex: 1;
  /* 让内容部分占据剩余空间 */
}

.info-content ul {
  padding-left: 10px;
  /* 为用户清单提供一些左边距 */
}

.info-content li {
  list-style-type: none;
  /* 移除列表项目符号 */
}




.user-container {
  display: flex;
  overflow-x: auto;
  overflow-y: auto;
  padding-bottom: 10px;
}

.user-item {
  max-height: 800px;
  min-height: 200px;
  /* 最小高度为 200px */
  background-color: #d8ffe2;
  border-radius: 10px;
  width: 400px;
  /* 设置宽度 */
  margin-right: 10px;
  /* 右边距 */
  padding: 10px 10px 10px 30px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
}

.user-item>* {
  text-align: left;
  /* 文字左对齐 */
  align-self: flex-start;
  /* 垂直方向上靠上对齐 */
  margin-bottom: 0px;
  /* 行与行之间的间距 */
  margin-left: 20px;
}

.invoice-item {
  flex: 1 1 44%;
  /* 每个发票项尝试占据45%的宽度 */
  margin: 10px;

  padding: 20px;
  padding-left: 40px;

  background-color: #aaffdf;
  /* 背景颜色 */
  border-radius: 10px;
  /* 圆角边框 */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  /* 阴影效果 */
  text-align: left;
}

.invoice-item p {
  margin: 0;
  /* 调整上下外边距为5px，左右外边距保持为0 */
  padding: 0;
  /* 设置内边距为5px */
}
</style>
